import React, { Component } from 'react';
import { Button, HelpBlock } from 'react-bootstrap';
import { Field } from 'redux-form';
import FormField from './FormField.jsx';

export default class LoginForm extends Component {

    render() {
      const {
        error,
        handleSubmit,
        pristine,
        invalid,
        submitting,
      } = this.props;

      return (
        <div className="wrapper">
          <form
            className="form-signin"
            onSubmit={handleSubmit}
          >
            <h2 className="form-signin-heading">Please login</h2>
            <br />
            <Field
              component={FormField}
              label="Email"
              name="email"
              type="text"
            />
            <Field
              component={FormField}
              label="Password"
              name="password"
              type="password"
            />
            <br />
            <Button
              className="button"
              bsStyle="primary"
              type="submit"
              disabled={invalid || submitting}
            >
                        Login
            </Button>
            <HelpBlock>{error && <div className="error-msg">{error}</div>}</HelpBlock>
          </form>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.jsx